import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import LoadingIndication from '../../common/loading-indicator';

import TeamMemberBox from '../../common/team-member-box';
import Button from '../../common/button/button';

import './team-section.css';

export default class TeamSection extends Component {
  render() {
    let extraJSX;

    const { teamMembers } = this.props;
    
    if (!teamMembers) {
      extraJSX = (
        <LoadingIndication />
      );
    }
    else {
      if (teamMembers.length === 0) {
        extraJSX = (
          <div>
            <p>There are no team members</p>
          </div>
        );
      }
      else {
        extraJSX = (
          <div className='team-container'>
            <div className='team-members'>
              {
                teamMembers.map((member, i) => 
                  <div key={ `team-member-${i}` } className='little-grow-animation team-member'>
                    <TeamMemberBox { ...member } isOnlyTwitterMediaShown={ false } />
                  </div>
                )
              }
            </div>

            <Link to='/team' title='Our Team'>
              <Button 
                label='Explore More' 
                isDark={ this.props.className !== 'dark' } />
            </Link>     
          </div>                 
        );
      }
    }

    return (
      <section className={ `${ this.props.className } section-container team-section-container` }>
        <h3 className='section-title'>
          Meet Our Team
        </h3>

        { extraJSX }
      </section>
    );
  }
}